// PDF.js, CARGADO SOLO CUANDO HACE FALTA. Mismo patrón que src/lib/cornerstoneInit.js.
//
// POR QUÉ ESTÁ AQUÍ Y NO IMPORTADO ARRIBA DEL TODO. Para colocar la firma dentro de un documento hay
// que PINTAR el PDF: el administrador tiene que ver la página y arrastrar el recuadro encima. Eso
// obliga a un motor de PDF en el navegador, y el motor pesa. Medido en este proyecto (vite build):
//
//     pdf.min.mjs  ....  444 KB en disco  →  ~128 KB gzip en su propio trozo
//     pdf.worker.min.mjs 1.233 KB en disco →  ~340 KB gzip, fichero aparte que carga el worker
//
// El paquete de la aplicación ya va por 5,4 MB (1,31 MB gzip) por el visor de imagen, así que meter
// esto dentro habría sido subirle ~470 KB gzip A TODO EL MUNDO —recepción, auxiliares, el móvil de
// quien solo entra a fichar— para una pantalla que usa el administrador cuatro veces al año.
//
// Con el import DINÁMICO, rolldown deja pdf.js en un trozo aparte (`assets/pdf-*.js`, 427,55 KB /
// 127,43 KB gzip) que NO se descarga hasta que alguien pulsa "Colocar la firma". Medido en este
// proyecto: al añadir la pantalla, el paquete principal subió unos 27 KB, y esos 27 KB son el código
// de la pantalla — de pdf.js, ni un byte. (El total del paquete no se escribe aquí a propósito: se
// mueve con cada pantalla nueva y un número clavado en un comentario envejece en una semana.) El
// worker sale además como fichero suelto (`assets/pdf.worker.min-*.mjs`, 1.232,81 KB) y lo pide el
// propio pdf.js cuando arranca, así que tampoco entra en ninguna descarga inicial.
//
// LO QUE SÍ CUESTA, Y NO SE VE EN EL PAQUETE: `pdfjs-dist` arrastra `@napi-rs/canvas` como
// dependencia OPCIONAL (para pintar PDF en Node, que en un navegador no sirve de nada). En este
// árbol son ~35 MB de pdfjs-dist más ~37 MB de binarios de @napi-rs, así que el `npm ci` de
// frontend/ en el VPS se trae unos 70 MB más de los que se ven en `dist/`. NO se arregla con
// `npm ci --omit=optional`: rolldown publica su binario nativo (`@rolldown/binding-*`) también como
// dependencia opcional, así que omitirlas deja el build sin poder arrancar. Queda dicho porque el
// disco del VPS es finito y esto no aparece en ninguna tabla de tamaños.
//
// EL WORKER SE SIRVE DESDE LA PROPIA APLICACIÓN (`?url` de Vite le pone la ruta con su hash en
// /assets). Nada de CDN: el navegador de la clínica está detrás de Cloudflare y hay instalaciones
// sin salida a internet; un worker que no carga deja el visor en negro sin decir por qué.
let promesa = null;

// EL WORKER NO PUEDE DEPENDER DE COMO ESTE CONFIGURADO EL NGINX DE CADA CLINICA.
//
// LO QUE PASO EL 1-SEP EN PRODUCCION. El fichero del worker es un `.mjs`, y nginx de fabrica NO tiene
// ese tipo declarado en `mime.types`: lo sirve como `application/octet-stream`. Un navegador se niega
// a ejecutar un modulo servido asi, con lo cual pdf.js no pudo crear el worker, cayo a su plan B —el
// «fake worker», que lo carga en el hilo principal con un `import()`— y ese plan B fallo por lo
// MISMO. Resultado en pantalla: «Aqui no se puede colocar la firma», y NINGUNA firma se podia colocar
// en toda la aplicacion.
//
// Se arreglo en ese servidor añadiendo `mjs` a `mime.types`. Pero eso **no se puede repetir a mano en
// cada instalacion**: cada clinica va a tener su nginx, y una funcion clinica no puede depender de que
// alguien se acuerde de tocar un fichero de configuracion. Asi que aqui se comprueba y, si el servidor
// no lo sirve como JavaScript, el worker se monta desde un Blob con el tipo correcto puesto por
// nosotros — inmune a la configuracion del servidor.
//
// SE COMPRUEBA, NO SE ASUME: la ruta rapida (la URL tal cual) es la buena y se usa siempre que el
// servidor este bien. El rodeo del Blob solo entra cuando hace falta, y deja dicho por consola por
// que ha entrado, para que quien instale esa clinica pueda arreglar su nginx de verdad.
const TIPOS_JS = /^(text|application)\/(java|ecma)script/i;

async function urlDelWorker(url) {
  try {
    const r = await fetch(url, { method: 'HEAD' });
    const tipo = r.headers.get('content-type') || '';
    if (r.ok && TIPOS_JS.test(tipo)) return url;          // el servidor lo sirve bien: nada que hacer
    console.warn('[pdf.js] El servidor sirve el worker como "' + tipo + '" en vez de JavaScript. '
      + 'Se carga desde un Blob para que la firma funcione igual. '
      + 'Arreglo de verdad: añadir `mjs` a /etc/nginx/mime.types en ese servidor.');
  } catch (e) {
    console.warn('[pdf.js] No se ha podido comprobar como se sirve el worker (' + e.message
      + '). Se carga desde un Blob.');
  }
  // El rodeo: se trae el fichero y se crea el worker desde memoria, con el tipo puesto aqui.
  const codigo = await (await fetch(url)).text();
  return URL.createObjectURL(new Blob([codigo], { type: 'text/javascript' }));
}

async function cargar() {
  const pdfjs = await import('pdfjs-dist');
  const { default: workerUrl } = await import('pdfjs-dist/build/pdf.worker.min.mjs?url');
  pdfjs.GlobalWorkerOptions.workerSrc = await urlDelWorker(workerUrl);
  return pdfjs;
}

// Idempotente. Si falla —una red que se cae a mitad de la descarga del trozo— NO se recuerda el
// fallo: se borra la promesa para que el botón de "Reintentar" pueda volver a intentarlo de verdad.
// Guardar la promesa rechazada dejaba el visor muerto hasta recargar la página entera.
export function initPdfjs() {
  if (!promesa) {
    promesa = cargar().catch((e) => { promesa = null; throw e; });
  }
  return promesa;
}
